// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {BookingState} from 'redux/uiState/layout/booking/BookingState';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  SET_BOOKING_IN_PROCESS,
  SET_JOURNEY_PARAMS,
} from 'redux/uiState/layout/booking/actions';
import {bookingState} from 'redux/uiState/layout/LayoutState';

const initialState: BookingState = {
  journeyId: 0,
  token: '',
  bookingInProcess: false,
};

const actionCreators: ActionHandlers<BookingState> = {
  [PURE(SET_JOURNEY_PARAMS)]: (state: BookingState, action) => ({
    ...state,
    journeyId: action.journeyId,
    token: action.token,
  }),
  [PURE(SET_BOOKING_IN_PROCESS)]: (state: BookingState, action) => ({
    ...state,
    bookingInProcess: action.bookingInProcess,
  }),
};

// $FlowIgnore
export const bookingReducer: Reducer<BookingState> = // $FlowIgnore
  createReducerUsingActionHandlers<BookingState>(initialState, actionCreators);

export const getJourneyId: Selector<number> = createSelector(
  bookingState,
  (state: BookingState) => state.journeyId
);

export const getToken: Selector<string> = createSelector(
  bookingState,
  (state: BookingState) => state.token
);

export const getBookingInProcess: Selector<boolean> = createSelector(
  bookingState,
  (state: BookingState) => state.bookingInProcess
);
